import axios from 'axios'
import qs from 'qs'

export const techniqueService = ({
  getAllTechniques (token) {
    return axios.get('/api/Techniques', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createTechnique (token, TechniqueObj) {
    var stringifiedObj = qs.stringify(TechniqueObj)
    return axios.post('/api/Technique/Create', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateTechnique (token, TechniqueObj) {
    var stringifiedObj = qs.stringify(TechniqueObj)
    return axios.put('/api/Technique/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteTechnique (token, techniqueId) {
    return axios.delete('/api/Technique?TechniqueId=' + techniqueId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  associateTechnique (token, challengeId) {
    return axios.post('/api/Technique/Associate?challengeId=' + challengeId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAssociateTechniques (token, challengeId) {
    return axios.get('/api/Challenge/Techniques?challengeId=' + challengeId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/technique-service.js